import { useEffect, useState } from "react";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import { useAuthContext } from "../../../context/AuthContext";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import getResourceDetails from "../../../apis/getResourceDetails";
import ProfileCard from "./ProfileCard";
import { useHistory } from "react-router-dom";

const ResourceProfile = (props) => {
  const history = useHistory();
  const { resourceSlug } = props;
  const searchParams = new URLSearchParams(window.location.search);
  const { userDetails } = useAuthContext();
  const firmType = JSON.parse(userDetails).firm_details?.firm_type;
  const user_slug = JSON.parse(userDetails).user_slug;
  const current_user_firm = JSON.parse(userDetails).firm_details;
  const user_primary_role = JSON.parse(userDetails).user_primary_role;
  const [displayView, setDisplayView] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const [resourceDetails, setResourceDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [rmId, setRmId] = useState(false);

  useEffect(() => {
    if (resourceDetails) {
      setRmId(resourceDetails.profile_details.firm_id);
    }
  }, [resourceDetails]);

  useEffect(() => {
    if (searchParams) {
      if (searchParams.get("cv")) {
        changeView("client");
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (user_slug !== undefined && resourceSlug !== undefined) {
      Promise.all([getResourceDetails(resourceSlug, user_slug)])
        .then(async ([data]) => {
          if (data?.data?.status === 1) {
            await setResourceDetails(data?.data?.resource_details);
            await setDisplayView(data?.data?.resource_details.resource_access);
            await setIsProfileLoading(false);
          } else {
            setErrorMessage(data?.data?.message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsProfileLoading(false);
        });
    }
  }, [user_slug, resourceSlug]);

  const changeView = async (type) => {
    searchParams.delete("cv");
    await setDisplayView(type);
  };

  const CandidateHeader = () => {
    return (
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
        {user_primary_role !== "3" ? (
          <div className="d-flex align-items-center gap-3">
            {/* Back Button */}
            <div
              onClick={() => history.goBack()}
              className="d-flex align-items-center justify-content-center p-0 cursor-pointer"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#fff",
                boxShadow: "0 0 4px rgba(0, 0, 0, 0.1)",
                border: "none",
                borderRadius: "50px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </div>

            {/* Title */}
            {/* <span className="fw-bold fs-5">
              {resourceDetails?.profile_details?.profile_name}
            </span> */}
          </div>
        ) : (
          <div className="d-flex align-items-center gap-3" />
        )}

        {/* Button Group */}
        {(rmId === current_user_firm.firm_id && user_primary_role !== "4") ||
        user_primary_role === "3" ? (
          <div className="btn-group" role="group" aria-label="View toggle">
            <Link
              to={
                firmType === "1"
                  ? "/my-team/details/" + resourceSlug
                  : "/resources/details/" + resourceSlug
              }
            >
              <Button
                onClick={() => changeView("default")}
                variant={
                  displayView === "default" ? "primary" : "outline-secondary"
                }
                size="sm"
              >
                Default View
              </Button>
            </Link>
            {user_primary_role === "2" ? (
              <Button
                onClick={() => changeView("client")}
                variant={
                  displayView === "client" ? "primary" : "outline-secondary"
                }
                size="sm"
                className="ms-3"
              >
                Client View
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };

  const displayPageContent = () => {
    return (
      <>
        {isProfileLoading ? (
          <LoadingPageSm title={"Loading resource details..."} />
        ) : !resourceDetails ? (
          <div
            className="alert alert-danger d-flex align-items-center"
            role="alert"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
              viewBox="0 0 16 16"
              role="img"
              aria-label="Warning:"
            >
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </svg>
            <div>{errorMessage}</div>
          </div>
        ) : (
          <>
            {CandidateHeader()}
            <ProfileCard
              displayView={displayView}
              resourceDetails={resourceDetails}
              resourceSlug={resourceSlug}
            />
          </>
        )}
      </>
    );
  };

  return displayPageContent();
};

export default ResourceProfile;
